.IOJack {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    &.isInput {
        & .IOJack__label {
            color: var(--soniq-t--global--text--color--status--info--default);
        }
    }

    &.isOutput {
        & .IOJack__label {
            color: var(--soniq-t--global--text--color--brand--default);
        }
    }

    &.isLive.isInput {
        & .IOJack__signal {
            background: var(--soniq-t--global--palette--cyan);
            border-color: var(--soniq-t--global--border--color--status--info--default);
            box-shadow: 0 0 10px 2px var(--soniq-t--global--background--color--status--info--default);
        }
    }

    &.isLive.isOutput {
        & .IOJack__signal {
            background: var(--soniq-t--global--palette--hot-pink);
            border-color: var(--soniq-t--global--border--color--status--danger--default);
            box-shadow: 0 0 10px 2px var(--soniq-t--global--background--color--status--danger--default);
        }
    }
}

.IOJack__socket {
    position: relative;
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background: radial-gradient(circle at 35% 30%, var(--soniq-t--global--background--color--surface--hover), transparent 60%),
    var(--soniq-t--global--background--color--surface--panel);
    border: 1px solid var(--soniq-t--global--border--color--card--default);
    display: grid;
    place-items: center;

    /* hex-nut ring */
    &::before {
        content: "";
        position: absolute;
        inset: 6px;
        background: var(--soniq-t--global--background--color--surface--event);
        clip-path: polygon(25% 3%, 75% 3%, 98% 50%, 75% 97%, 25% 97%, 2% 50%);
    }
}

.IOJack__bore {
    position: relative;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--soniq-t--global--palette--black);
    border: 3px solid var(--soniq-t--global--border--color--event--opaque);
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.7);
}

.IOJack__label {
    font-size: var(--soniq-t--global--font--size--field-label);
    font-weight: var(--soniq-t--global--font--weight--medium);
    letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
    text-transform: uppercase;
    font-family: var(--soniq-t--global--font--family--mono);
    color: var(--soniq-t--global--text--color--label--default);
}

.IOJack__signal {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--soniq-t--global--background--color--status--muted--default);
    border: 1px solid var(--soniq-t--global--border--color--status--muted--default);
}
